import "./index.less";
import * as React from "react";
import { DefaultSizes, XS } from "../../../types";
import { Tooltip, TooltipProps } from "reactstrap";
import { observer } from "mobx-react";

export type AtTooltipDisplayMode = "light" | "dark";

export interface IAtTooltipProps extends TooltipProps {
    displayMode?: AtTooltipDisplayMode;
    size?: XS | DefaultSizes;
}

export const AtTooltip: React.FC<IAtTooltipProps> = observer((props) => {
    const {
        target,
        displayMode = "light",
        size = "md",
        isOpen,
        toggle,
        children,
        className,
        innerClassName,
        ...otherProps
    } = props;

    const baseClassNames = `tooltip-display-${displayMode} size-${size}`;

    const getClassNames: () => string = () => {
        let classNames = `AtTooltip ${baseClassNames}`;

        if (className) {
            classNames += ` ${className}`;
        }

        return classNames;
    };

    const getInnerClassNames: () => string = () => {
        let innerClassNames = `AtTooltip-inner ${baseClassNames}`;

        if (innerClassName) {
            innerClassNames += ` ${innerClassName}`;
        }

        return innerClassNames;
    };

    let isTooltipOpen: boolean;
    let toggleTooltipState: () => void;

    if (isOpen === undefined || toggle === undefined) {
        const [_isOpen, _setIsOpen] = React.useState(false);
        isTooltipOpen = _isOpen;
        toggleTooltipState = () => {
            _setIsOpen(!_isOpen);
        };
    } else {
        isTooltipOpen = isOpen;
        toggleTooltipState = toggle;
    }

    return (
        <Tooltip
            isOpen={isTooltipOpen}
            toggle={toggleTooltipState}
            defaultOpen={false}
            className={getClassNames()}
            innerClassName={getInnerClassNames()}
            target={target}
            // @ts-ignore
            hideArrow={true}
            {...otherProps}
        >
            {children}
        </Tooltip>
    );
});
